import { EntityConstants } from "./GenericTypes";

export const entitiesConstants: EntityConstants = {
  resource: "entities",
  frontendIndexRoute: "uuid",
  entitySingular: "entity",
  entityPlural: "entities",
  icon: "fingerprint",
};
